import { render } from "./FileUsages.vue?vue&type=template&id=64cc8ac8&ts=true"
import script from "./FileUsages.vue?vue&type=script&lang=ts"
export * from "./FileUsages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__